






























import { Component, Prop, Vue } from "vue-property-decorator";

import ServiceMenuStatusIcon from "@/components/service-status/ServiceMenuStatusIcon.vue";
import { ServiceMenuStatus, ServiceMenuStatusIconType } from "@/consts/const";

@Component({
  components: { ServiceMenuStatusIcon },
})
export default class ServiceSummaryStatus extends Vue {
  @Prop({ default: false }) wide!: boolean;
  @Prop({ required: true }) statusList!: ServiceMenuStatus[];
  private ServiceMenuStatusIconType = ServiceMenuStatusIconType;
}
